import { render, staticRenderFns } from "./RuConfidential.vue?vue&type=template&id=42e50da4&"
import script from "./RuConfidential.vue?vue&type=script&lang=js&"
export * from "./RuConfidential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports